import isPlainObject from 'lodash/isPlainObject';
import isArray from 'lodash/isArray';

// The camelCase method of lodash can not be used here since it converts
// also something like "address.region_id" into "addressRegionId" which we
// do not want
export function camelCaseString(str) {
    return str.replace(/(_\w)/g, s => s[1].toUpperCase());
}

export default function camelCase(obj) {
    if (isArray(obj)) {
        return obj.map(item => camelCase(item));
    }

    if (!isPlainObject(obj)) return obj;

    return Object.keys(obj).reduce((result, key) => {
        result[camelCaseString(key)] = isPlainObject(obj[key]) || isArray(obj[key])
            ? camelCase(obj[key])
            : obj[key];
        return result;
    }, {});
}
